document.addEventListener("DOMContentLoaded", () => {
  const mapEl = document.getElementById("map");

  console.log("mapEl", mapEl);

  if (!mapEl) return;

  let mapConfig = {
    center: [115.171951, -8.788334],
    zoom: 8.6,
  };

  if (window.mapSettings) {
    mapConfig = mapSettings;
  }

  if (innerWidth < 800) mapConfig.zoom = 10;

  const map = new maplibregl.Map({
    container: "map", // container id
    style: {
      version: 8,
      sources: {
        "raster-tiles": {
          type: "raster",
          tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
          tileSize: 256,
          minzoom: 0,
          maxzoom: 19,
        },
      },
      layers: [
        {
          id: "simple-tiles",
          type: "raster",
          source: "raster-tiles",
          attribution: "© OpenStreetMap contributors",
        },
      ],
      id: "blank",
    },
    ...mapConfig,
  });

  if (landMapLocation) {
    landMapLocation.forEach((marker) => {
      console.log("marker", marker);
      const coordinates = marker.coordinates;
      // create a DOM element for the marker
      const el = document.createElement("div");
      el.className = "marker";
      el.style.backgroundImage = `url(${marker.thumb})`;
      el.style.width = innerWidth < 800 ? "50px" : `2vw`;
      el.style.height = innerWidth < 800 ? "50px" : `2vw`;

      el.addEventListener("click", () => {
        if (!marker.link) return;
        window.location.href = marker.link;
        // window.alert(marker.properties.message);
      });

      // add marker to map
      new maplibregl.Marker({ element: el })
        .setLngLat([coordinates[1], coordinates[0]])
        .addTo(map);
    });
  }
});
